// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../types.schema';

export const saveLogsPayloadSchema = z.object({
  duration: z.number(),
  type: z.string(),
  subtype: z.string(),
  annotation: urlSchema.optional(),
  queue: urlSchema.optional(),
});
